import { checkPathContainsSubPath } from './generateObjectHelpers';

export const getTypographyColor = (type, preview, invalidpath, updatepath) => {
  if (type === 'add') return '';

  const isInvalid =
    checkPathContainsSubPath(invalidpath, 'fileHash', '', updatepath) ||
    invalidpath?.some((item) => item.path.includes(`/${preview.filename}/fileHash`)) ||
    invalidpath?.some((item) => item.path === `/${preview.filename}`);

  if (isInvalid) return 'red';

  const isUpdate =
    updatepath?.some((item) => item.path.includes(`/${preview.filename}/fileHash`)) ||
    updatepath?.some((item) => item.path === `/${preview.filename}`) ||
    checkPathContainsSubPath(updatepath, 'fileHash', '', invalidpath);

  if (isUpdate) return 'green';

  return '';
};

// 2. Get Status Text
export const getStatusText = (preview, invalidpath, updatepath) => {
  const isInvalid =
    checkPathContainsSubPath(invalidpath, 'fileHash', '', updatepath) ||
    invalidpath?.some((item) => item.path.includes(`/${preview.filename}/fileHash`)) ||
    invalidpath?.some((item) => item.path === `/${preview.filename}`);

  if (isInvalid) return '(Unauthorized change detected)';

  const isUpdate =
    updatepath?.some((item) => item.path.includes(`/${preview.filename}/fileHash`)) ||
    updatepath?.some((item) => item.path === `/${preview.filename}`) ||
    checkPathContainsSubPath(updatepath, 'fileHash', '', invalidpath);

  if (isUpdate) return '(Authorized change detected)';

  return <div>&nbsp;</div>;
};

// Helper function to get status text for history items
export const getHistoryStatusText = (status) => {
  // Normalize to lowercase for comparison, but handle both lowercase and mixed case
  const normalizedStatus = status?.toLowerCase();

  // Handle inProgress (mixed case) and inprogress (lowercase)
  if (status === 'inProgress' || normalizedStatus === 'inprogress') {
    return 'In Progress';
  }

  // Handle pendingRollback (mixed case) and pendingrollback (lowercase)
  if (status === 'pendingRollback' || normalizedStatus === 'pendingrollback') {
    return 'Pending Rollback';
  }

  // Handle pendingApproval (mixed case) and pendingapproval (lowercase)
  if (status === 'pendingApproval' || normalizedStatus === 'pendingapproval') {
    return 'Pending Approval';
  }

  // Handle other statuses (lowercase and mixed case)
  if (normalizedStatus === 'open') {
    return 'Open';
  }
  if (normalizedStatus === 'closed') {
    return 'Closed';
  }
  if (normalizedStatus === 'keep') {
    return 'Keep';
  }
  if (normalizedStatus === 'rollback') {
    return 'Rollback';
  }
  if (normalizedStatus === 'reject') {
    return 'Reject';
  }

  // Return original status if no match
  return status;
};

// 3. Get Card Background
export const getCardBackground = (type, preview, invalidpath, updatepath, height, authorized, unauthorized) => {
  if (type === 'add') return '';

  const isInvalid =
    checkPathContainsSubPath(invalidpath, 'fileHash', '', updatepath) ||
    (height === 1 && unauthorized) ||
    invalidpath?.some((item) => item.path.includes(`/${preview.filename}/fileHash`)) ||
    invalidpath?.some((item) => item.path === `/${preview.filename}`);

  if (isInvalid) return 'var(--red-500, #ff001a52)';

  const isUpdate =
    (height === 1 && authorized) ||
    updatepath?.some((item) => item.path.includes(`/${preview.filename}/fileHash`)) ||
    updatepath?.some((item) => item.path === `/${preview.filename}`) ||
    checkPathContainsSubPath(updatepath, 'fileHash', '', invalidpath);

  if (isUpdate) return 'var(--yellow-100, #dcffd7)';

  return '';
};
